var featured_meetings_slider = ( function( $ ) {

	var $slider;

	var _init = function() {
		$slider = $( '#featured-meetings' ).find( '.owl-carousel' );

		_setup_slider();
	};

	var _setup_slider = function () {
		$slider.on( 'initialized.owl.carousel', _slider_initialised );

		var $items = $slider.find('.item');

		if ( $items.length <= 1 ) {
			return;
		}

		$slider.owlCarousel( {
			items: 1,
			loop: true,
			autoplay: true,
			autoplayHoverPause: true
		} );
	};

	var _slider_initialised = function( event ) {
		$slider.find( '.owl-item .item' ).show();
	};

	if ( $( '#featured-meetings' ).length > 0 ) {
		$( document ).ready( _init );
	}

	return {};

} )( jQuery );

module.exports = featured_meetings_slider;